var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReddit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 8.12a1.974 1.974 0 00-3.338-1.352A9.62 9.62 0 009.46 5.106l.878-4.218 2.892.609a1.352 1.352 0 10.175-.825L10.095.01a.419.419 0 00-.5.324l-1 4.69a9.646 9.646 0 00-5.27 1.663 1.973 1.973 0 10-2.176 3.23 3.881 3.881 0 000 .595C1.15 13.54 4.676 16 9.027 16s7.878-2.46 7.878-5.488a3.884 3.884 0 000-.595A1.973 1.973 0 0018 8.12zM4.487 9.47a1.352 1.352 0 112.704 0 1.352 1.352 0 01-2.704 0zm7.85 3.717A5.188 5.188 0 019 14.23a5.188 5.188 0 01-3.337-1.04.365.365 0 01.513-.514 4.418 4.418 0 002.81.851 4.43 4.43 0 002.825-.824.378.378 0 01.527.54v-.054zm-.242-2.31a1.351 1.351 0 111.35-1.353 1.35 1.35 0 01-1.364 1.406l.014-.054z",
    fill: "#23024D"
  })));
}
export default SvgReddit;